import { Base } from 'components/template';
import { ProgressBar } from 'components/molecules';
import logo from '_utilities/images/logo.png';
import { Link } from 'react-router-dom';

const prefix = "v-user-with-account";

const UserWithAccount = () => {
  return (
    <Base>
      <div className={`${prefix} flex flex-wrap flex-col p-3 mx-auto w-full sm:w-2/3 md:w-3/5 lg:w-4/12 max-w-[550px]`}>
        <div className="flex flex-wrap flex-col gap-1">
          <img src={logo} alt="nbsk-logo" className="w-[55%] mx-auto mb-5"/>
          <ProgressBar max={1} progress={1} />
          <p className="text-center text-3xl font-bold mx-auto mt-5">Este usuario ya tiene</p>
          <p className="text-center text-3xl font-bold mx-auto mb-8">una cuenta creada</p>
          <p className="text-center text-xl mx-auto">Accede a tu cuenta</p>
          <p className="text-center text-xl mx-auto mb-8"><Link to="/account/login" className='underline font-bold'>Iniciar sesión</Link></p>

          <p className="text-center text-xl mx-auto">¿Olvidaste tu contraseña?</p>
          <p className="text-center text-xl mx-auto mb-5"><Link to="/account/forgot" className='underline font-bold'>Recuperar contraseña</Link></p>
        </div>
      </div>
    </Base>
  );
};

export default UserWithAccount;

